import React, { useCallback, useState } from 'react';
import {
  STEPS,
  ChatAPI,
  types,
  useLocalChat,
} from '@guuru/chat-web';
import SmartFormIntentOptions from './SmartFormIntentOptions';
import ChatIntentOptions from './ChatIntentOptions';

type ChatMessage = React.ComponentProps<typeof ChatIntentOptions>['message'];
type SmartFormMessage = React.ComponentProps<typeof SmartFormIntentOptions>['message'];

interface ChatRenderIntentSelectionProps {
  message: ChatMessage | SmartFormMessage;
  readOnly: boolean;
  partnerId?: string;
  locale?: string;
  // eslint-disable-next-line no-unused-vars
  dispatch?: (_: {
    type: keyof typeof types;
    processArgs: {
      automationBehavior: {
        subscriptionOptionsText: string;
        subscriptionPriority: string;
        subscriptionTarget: string;
        subscriptionAnswer: string;
      }
    };
  }) => void;
}

const ChatRenderIntentSelection = function ({
  message,
  readOnly,
  partnerId = '',
  dispatch = () => {},
  locale = 'en',
}: ChatRenderIntentSelectionProps) {
  const { currentChatStep } = useLocalChat();
  const requestIntent = currentChatStep === STEPS.requestIntentSelection;
  const [
    showOptions,
    setShowOptions,
  ] = useState(requestIntent);

  const handleSelection = useCallback((intent: { name: string }) => {
    const automationBehavior = ChatAPI.storeRetrieveAutomationBehavior(
      partnerId,
    );
    setShowOptions(false);
    dispatch({
      type: types.CHAT_RUN_NEXT_STEP,
      processArgs: {
        automationBehavior: { ...automationBehavior, ...intent },
      },
    });
  }, [dispatch, partnerId]);

  const isSmartForm = message.smartFormStyle === true;
  const IntentOptions = isSmartForm
    ? SmartFormIntentOptions
    : ChatIntentOptions;
  const showMultiIntentOptions = (requestIntent && showOptions) || readOnly;

  return (
    <IntentOptions
      handleSelection={handleSelection}
      languageCode={locale}
      message={message}
      showOptions={showMultiIntentOptions}
      readOnly={readOnly}
    />
  );
};

export default ChatRenderIntentSelection;
